module.exports = __webpack_public_path__ + "media/site_templates/www.buildersnearme.net.au/images/our_services_3-21f79d2cf2e3162dadcc97e36e21b72d.jpg";